const ROOT = 'ADMIN_ORGANIZATION_';

const actions = {
  TOUCH: `${ROOT}TOUCH`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  LOAD_REQUEST: `${ROOT}LOAD_REQUEST`,
  LOAD_SUCCESS: `${ROOT}LOAD_SUCCESS`,
  LOAD_ERROR: `${ROOT}LOAD_ERROR`,
  UPDATE_REQUEST: `${ROOT}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${ROOT}UPDATE_SUCCESS`,
  UPDATE_ERROR: `${ROOT}UPDATE_ERROR`,
  LOAD_ADMIN_MANAGER_REQUEST: `${ROOT}LOAD_ADMIN_MANAGER_REQUEST`,
  LOAD_ADMIN_MANAGER_SUCCESS: `${ROOT}LOAD_ADMIN_MANAGER_SUCCESS`,
  LOAD_ADMIN_MANAGER_ERROR: `${ROOT}LOAD_ADMIN_MANAGER_ERROR`,
  UPDATE_ADMIN_MANAGER_REQUEST: `${ROOT}UPDATE_ADMIN_MANAGER_REQUEST`,
  UPDATE_ADMIN_MANAGER_SUCCESS: `${ROOT}UPDATE_ADMIN_MANAGER_SUCCESS`,
  UPDATE_ADMIN_MANAGER_ERROR: `${ROOT}UPDATE_ADMIN_MANAGER_ERROR`,
  // Global Configurations
  UPDATE_NCNS_PERIOD_REQUEST: `${ROOT}UPDATE_NCNS_PERIOD_REQUEST`,
  UPDATE_NCNS_PERIOD_SUCCESS: `${ROOT}UPDATE_NCNS_PERIOD_SUCCESS`,
  UPDATE_NCNS_PERIOD_ERROR: `${ROOT}UPDATE_NCNS_PERIOD_ERROR`,
  UPDATE_MINIMUM_BOOKING_TIME_REQUEST: `${ROOT}UPDATE_MINIMUM_BOOKING_TIME_REQUEST`,
  UPDATE_MINIMUM_BOOKING_TIME_SUCCESS: `${ROOT}UPDATE_MINIMUM_BOOKING_TIME_SUCCESS`,
  UPDATE_MINIMUM_BOOKING_TIME_ERROR: `${ROOT}UPDATE_MINIMUM_BOOKING_TIME_ERROR`,
  UPDATE_CLOCK_IN_PERIOD_REQUEST: `${ROOT}UPDATE_CLOCK_IN_PERIOD_REQUEST`,
  UPDATE_CLOCK_IN_PERIOD_SUCCESS: `${ROOT}UPDATE_CLOCK_IN_PERIOD_SUCCESS`,
  UPDATE_CLOCK_IN_PERIOD_ERROR: `${ROOT}UPDATE_CLOCK_IN_PERIOD_ERROR`,
  UPDATE_FLAGGED_TIMESHEETS_REQUEST: `${ROOT}UPDATE_FLAGGED_TIMESHEETS_REQUEST`,
  UPDATE_FLAGGED_TIMESHEETS_SUCCESS: `${ROOT}UPDATE_FLAGGED_TIMESHEETS_SUCCESS`,
  UPDATE_FLAGGED_TIMESHEETS_ERROR: `${ROOT}UPDATE_FLAGGED_TIMESHEETS_ERROR`,
  UPDATE_BULK_JOBS_UPLOAD_REQUEST: `${ROOT}UPDATE_BULK_JOBS_UPLOAD_REQUEST`,
  UPDATE_BULK_JOBS_UPLOAD_SUCCESS: `${ROOT}UPDATE_BULK_JOBS_UPLOAD_SUCCESS`,
  UPDATE_BULK_JOBS_UPLOAD_ERROR: `${ROOT}UPDATE_BULK_JOBS_UPLOAD_ERROR`,
  UPDATE_WORKERS_BULK_UPLOAD_REQUEST: `${ROOT}UPDATE_WORKERS_BULK_UPLOAD_REQUEST`,
  UPDATE_WORKERS_BULK_UPLOAD_SUCCESS: `${ROOT}UPDATE_WORKERS_BULK_UPLOAD_SUCCESS`,
  UPDATE_WORKERS_BULK_UPLOAD_ERROR: `${ROOT}UPDATE_WORKERS_BULK_UPLOAD_ERROR`,
  // Manager Settings
  UPDATE_BOOKING_FULFILLMENT_REQUEST: `${ROOT}UPDATE_BOOKING_FULFILLMENT_REQUEST`,
  UPDATE_BOOKING_FULFILLMENT_SUCCESS: `${ROOT}UPDATE_BOOKING_FULFILLMENT_SUCCESS`,
  UPDATE_BOOKING_FULFILLMENT_ERROR: `${ROOT}UPDATE_BOOKING_FULFILLMENT_ERROR`,
  UPDATE_CLOCK_IN_OUT_REQUEST: `${ROOT}UPDATE_CLOCK_IN_OUT_REQUEST`,
  UPDATE_CLOCK_IN_OUT_SUCCESS: `${ROOT}UPDATE_CLOCK_IN_OUT_SUCCESS`,
  UPDATE_CLOCK_IN_OUT_ERROR: `${ROOT}UPDATE_CLOCK_IN_OUT_ERROR`,
  // Agencies Configurations
  UPDATE_AGENCIES_CONFIGURATIONS_REQUEST: `${ROOT}UPDATE_AGENCIES_CONFIGURATIONS_REQUEST`,
  UPDATE_AGENCIES_CONFIGURATIONS_SUCCESS: `${ROOT}UPDATE_AGENCIES_CONFIGURATIONS_SUCCESS`,
  UPDATE_AGENCIES_CONFIGURATIONS_ERROR: `${ROOT}UPDATE_AGENCIES_CONFIGURATIONS_ERROR`,
  // Invoices Configuration
  LOAD_INVOICE_SORTING_RULES_FORM_DATA_REQUEST: `${ROOT}LOAD_INVOICE_SORTING_RULES_FORM_DATA_REQUEST`,
  LOAD_INVOICE_SORTING_RULES_FORM_DATA_SUCCESS: `${ROOT}LOAD_INVOICE_SORTING_RULES_FORM_DATA_SUCCESS`,
  LOAD_INVOICE_SORTING_RULES_FORM_DATA_ERROR: `${ROOT}LOAD_INVOICE_SORTING_RULES_FORM_DATA_ERROR`,
  ADD_INVOICE_SORTING_RULE: `${ROOT}ADD_INVOICE_SORTING_RULE`,
  REMOVE_INVOICE_SORTING_RULE: `${ROOT}REMOVE_INVOICE_SORTING_RULE`,
  CHANGE_INVOICE_SORTING_RULE: `${ROOT}CHANGE_INVOICE_SORTING_RULE`,
  MOVE_INVOICE_SORTING_RULE: `${ROOT}MOVE_INVOICE_SORTING_RULE`,
  UPDATE_INVOICE_SORTING_RULES_REQUEST: `${ROOT}UPDATE_INVOICE_SORTING_RULES_REQUEST`,
  UPDATE_INVOICE_SORTING_RULES_SUCCESS: `${ROOT}UPDATE_INVOICE_SORTING_RULES_SUCCESS`,
  UPDATE_INVOICE_SORTING_RULES_ERROR: `${ROOT}UPDATE_INVOICE_SORTING_RULES_ERROR`,
  // Agency Worker Configuration
  UPDATE_AGENCY_WORKER_REQUEST: `${ROOT}UPDATE_AGENCY_WORKER_REQUEST`,
  UPDATE_AGENCY_WORKER_SUCCESS: `${ROOT}UPDATE_AGENCY_WORKER_SUCCESS`,
  UPDATE_AGENCY_WORKER_ERROR: `${ROOT}UPDATE_AGENCY_WORKER_ERROR`,
} as const;

export default actions;
